<template>
  <v-container class="py-6">
    <v-card class="mx-auto" max-width="520">
      <v-card-title class="text-h6">
        {{ $t("incidentReports.chooseType.title") }}
      </v-card-title>

      <v-card-text class="pt-0">
        {{ $t("incidentReports.pleaseChoose") }}
      </v-card-text>

      <v-divider />

      <v-card-text class="pt-4">
        <v-btn
          color="primary"
          class="mb-3 pl-3 pr-3"
          large
          block
          @click="$emit('choose', 'short')"
        >
          <div class="btn-two-lines">
            <div class="btn-title">
              {{ $t("incidentReports.chooseType.nonReportable") }}
            </div>
            <div class="btn-subtitle">
              {{ $t("incidentReports.chooseType.nonReportableSub") }}
            </div>
          </div>
        </v-btn>

        <v-btn
          class="mb-3 pl-3 pr-3"
          color="primary"
          large
          block
          @click="$emit('choose', 'long')"
        >
          <div class="btn-two-lines">
            <div class="btn-title">
              {{ $t("incidentReports.chooseType.reportable") }}
            </div>
            <div class="btn-subtitle">
              {{ $t("incidentReports.chooseType.reportableSub") }}
            </div>
          </div>
        </v-btn>

        <v-btn
          class="pl-3 pr-3"
          color="primary"
          large
          block
          @click="$emit('choose', 'quick')"
        >
          <div class="btn-two-lines">
            <div class="btn-title">
              {{ $t("incidentReports.chooseType.nearMiss") }}
            </div>
            <div class="btn-subtitle">
              {{ $t("incidentReports.chooseType.nearMissSub") }}
            </div>
          </div>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "incidentReportQrCodeChooseType",
};
</script>
<style scoped>
.btn-two-lines {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  width: 100%;
}

.btn-title {
  font-weight: 600;
}

.btn-subtitle {
  font-size: 0.875rem;
  font-weight: 400;
  opacity: 0.9;
  margin-top: 2px;
}

@media screen and (max-width: 415px) {
  .btn-title {
    font-size: 0.75rem;
  }

  .btn-subtitle {
    font-size: 0.75rem;
  }
}

@media screen and (max-width: 370px) {
  .btn-title {
    font-size: 0.625rem;
  }

  .btn-subtitle {
    font-size: 0.625rem;
  }
}
</style>
